import "../omega-theme.augmentation";
import { defineTheme, type ThemeDefinition } from "@omega/theme";

import { MOBILE_THEME } from "./mobile.theme";

/**
 * Nord — холодная арктическая палитра (по мотивам nbp Nord).
 */
export const NORD_THEME: ThemeDefinition = defineTheme(
    {
        id: "nord",
        name: "Nord",
        scheme: "light",
        tokens: {
            color: {
                text: {
                    primary: "#1E293B",
                    secondary: "#3D5A80",
                    disabled: "#64748B",
                    emphasis: "#0F172A",
                    inverse: "#ECEFF4",
                    danger: "#BF616A",
                },
                background: { default: "#F0F2F6" },
                surface: {
                    base: "#FFFFFF",
                    hover: "#E5E9F0",
                    header: "#D8DEE9",
                    modal: "#ECEFF4",
                    disabled: "#CBD5E1",
                    selected: "#E5E9F0",
                },
                border: {
                    default: "#5E81AC",
                    focus: "#3D5A80",
                    muted: "#D8DEE9",
                    danger: "#BF616A",
                    disabled: "#B0B8C4",
                },
                accent: {
                    main: "#3D5A80",
                    contrastText: "#ECEFF4",
                },
                danger: { main: "#BF616A" },
                success: { main: "#A3BE8C", contrastText: "#1E293B" },
                warning: {
                    main: "#D08770",
                    contrastText: "#1E293B",
                },
                neutral: {
                    main: "#1E293B",
                    contrastText: "#ECEFF4",
                },
                status: {
                    success: "#A3BE8C",
                    successSurface: "#E7F0DF",
                    warningSurface: "#F6E6E0",
                    error: "#BF616A",
                    errorSurface: "#F5DDE0",
                    info: "#5E81AC",
                    infoSurface: "#E5E9F0",
                },
                alert: {
                    success: "#8FAE74",
                },
                skeleton: {
                    base: "#D8DEE9",
                    highlight: "#E5E9F0",
                },
            },
        },
    },
    { base: MOBILE_THEME },
);
